import { render } from "./BlueZonesIntro.vue?vue&type=template&id=f9434142&scoped=true"
import script from "./BlueZonesIntro.vue?vue&type=script&lang=js"
export * from "./BlueZonesIntro.vue?vue&type=script&lang=js"

import "./BlueZonesIntro.vue?vue&type=style&index=0&id=f9434142&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9434142"]])

export default __exports__